import { createFileRoute } from '@tanstack/react-router';
import ExpiredPassword from '../components/ExpiredPassword';
import { LanguagesContext, LanguageContextProps } from '../components/LanguagesContext';

export const Route = createFileRoute('/expired-password/$token')({
  beforeLoad: () => ({ documentTitle: { main: 'loginForm.login' } }),
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: ExpiredPasswordRoute,
});

function ExpiredPasswordRoute() {
  return (
    <LanguagesContext.Consumer>
      {(context: LanguageContextProps) => <ExpiredPassword context={context} />}
    </LanguagesContext.Consumer>
  );
}
